import {getXApiClientHeaders} from '@anywhere-expert/utils';

export default {
    ...getXApiClientHeaders(),
    Accept: 'application/json',
    'Content-Type': 'application/json',
};
